export type MinimumFeeStatus = 'pending' | 'not_required' | 'invoiced';

/** Solo las cuotas pendientes pueden seleccionarse para facturar */
export const isMinimumFeeInvoiceable = (fee?: Pick<MinimumFee, 'status'>): boolean =>
  String(fee?.status ?? '').toLowerCase() === 'pending';

/** Texto visible en columna Factura: ERP primero, id interno como respaldo */
export const getMinimumFeeInvoiceLabel = (fee?: Pick<MinimumFee, 'invoice_erp_number' | 'invoice_id'>): string => {
  const erpNumber = String(fee?.invoice_erp_number ?? '').trim();
  if (erpNumber) return erpNumber;

  const invoiceId = fee?.invoice_id;
  if (invoiceId == null || invoiceId === '') return '-';

  return `#${invoiceId}`;
};

export interface MinimumFee {
  id: string;
  team_id: string | number;
  team_name: string;
  year: number;
  month: number;
  minimum_fee: number;
  actual_billed_amount: number;
  storage_amount: number;
  total_computed_amount: number;
  difference_amount: number;
  status: MinimumFeeStatus;
  invoice_id: string | number | null;
  invoice_erp_number?: string | null;
  wallet_transaction_id: string | number | null;
  created_at: string;
  updated_at: string;
}

export interface MinimumFeesFilters {
  team_id?: string;
  year?: number;
  month?: number;
  status?: MinimumFeeStatus;
  invoice_id?: string;
  page?: number;
  per_page?: number;
}

export interface MinimumFeesMeta {
  page: number;
  per_page: number;
  total: number;
  last_page: number;
}

export interface MinimumFeesPage {
  data: MinimumFee[];
  meta: MinimumFeesMeta;
}

export interface SelectOption {
  label: string;
  value: string;
}
